const ActionType = {
  SET_SHOW_WARNING: 'SET_SHOW_WARNING',
};

export default ActionType;
